import React from "react";
import cssExports from "theme/styles/main.module.scss";

function useHideParentWhenNoChildren(selector: string) {
  const elements = document.querySelectorAll(selector);

  const getObserver = (observerElement: HTMLElement | null) =>
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (observerElement?.childNodes?.length) {
          observerElement?.classList.remove(cssExports.hidden);
        } else {
          observerElement?.classList.add(cssExports.hidden);
        }
      });
    });

  const config = { childList: true };

  React.useEffect(() => {
    const observers: MutationObserver[] = [];
    elements.forEach((element) => {
      if (!element?.hasChildNodes()) {
        element?.classList.add(cssExports.hidden);
      } else {
        element?.classList.remove(cssExports.hidden);
      }

      const observer = getObserver(element as HTMLElement);
      if (element) {
        observer.observe(element, config);
      }

      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => {
        observer.disconnect();
      });
    };
  }, [elements]);
}

export default useHideParentWhenNoChildren;
